import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { AdimeRequest, AdimeResponseItem } from "@/types/cppt";

async function create(data: AdimeRequest) {
  const response = await http.postData("/adime", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function update(id, data: AdimeRequest) {
  const response = await http.putData(`/adime/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: AdimeResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/adime`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/adime/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function destroy(id, alasan) {
  const response = await http
    .deleteDataParam(`/adime/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id, data) {
  const response = await http
    .postData(`/adime/${id}/verifikasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verify
};
